import axios from "axios";
import appConst from "../../constents/app.const";
class ServerApi {
  constructor(url, token) {
    this.url = url;
    this.token = token;
  }

  update(apiPrefix, id, datas, callback) {
    const url = this.url + "/api/v1/" + apiPrefix + "/" + id,
      _this = this;
    const formData = new FormData();
    formData.append("_method", "PATCH");
    Object.keys(datas).forEach((key) => {
      formData.append(key, datas[key]);
    });
    _this.ajaxCaller({ url: url, method: "post", data: formData }, callback);
  }

  create(apiPrefix, datas, callback) {
    const url = this.url + "/api/v1/" + apiPrefix,
      _this = this;
    const formData = new FormData();
    Object.keys(datas).forEach((key) => {
      formData.append(key, datas[key]);
    });
    _this.ajaxCaller({ url: url, method: "post", data: formData }, callback);
  }



  searchData(table, searchObj, skip, limit, fields = null, callback) {
    const url = this.url + "/api/v1/list/" + table,
      _this = this;
    let obj = {};
    if(searchObj){
      obj.params = {
        search: JSON.stringify(searchObj),
      };
    }
    if (fields) {
      obj.params.fields = JSON.stringify(fields);
    }
    obj.headers = { Authorization: "Bearer " + this.token };
    if (skip) {
      obj.params.skip = skip;
    }
    if (limit) {
      obj.params.limit = limit;
    }
    if(appConst.isBangla){
      if(obj.headers){
        obj.headers['lan'] = 'bd';
      }else{
        obj.headers ={
          lan:"bd"
        }
      }
    }else{
      if(obj.headers){
        obj.headers['lan'] = 'en';
      }else{
        obj.headers ={
          lan:"en"
        }
      }
    }
    axios
      .get(url, obj)
      .then((res) => {
        if (res.status == 200) {
          callback(_this.processResponse(res.data));
        } else if (res.status == 401 && notAuth == false) {
          window.__onLogout__();
        } else {
          callback(_this.processResponse(res.data));
        }
      })
      .catch((err) => {
        if (err.response.status == 401 && notAuth == false) {
          window.__onLogout__();
          return;
        } else {
          callback(_this.processResponse(res.data));
        }
      });
  }

  getData(apiPrefix, perPage, page, callback,editionalQuery = '') {
    const url = this.url + "/api/v1/" + apiPrefix + "?perPage=" + perPage + (page ? "&page=" + page : "") +editionalQuery,
      _this = this;
    this.ajaxCaller({ url: url, method: "get", data: {} }, callback);
  }
  getRoles(apiPrefix, perPage, page, callback,editionalQuery = '') {
    const url = this.url + "/api/v1/" + apiPrefix + "?perPage=" + perPage + (page ? "&page=" + page : "") +editionalQuery,
      _this = this;
    this.ajaxCaller({ url: url, method: "get", data: {} }, callback);
  }

  rawAjax({ type, url, success, failed, data, headers }) {
    let contentType = true;
    if (data instanceof FormData) {
      contentType = false;
    }
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        let parsedData;
        try {
          parsedData = JSON.parse(this.responseText);
        } catch (e) {
          parsedData = this.responseText;
        }
        if (success) {
          return success(parsedData);
        } else {
          return parsedData;
        }
      } else {
        if (this.status == 401) {
          window.__onLogout__();
        } else if (failed) {
          return failed(this);
        }
      }
    };

    xhttp.open(type, url, true);
    if (headers) {
      Object.keys(headers).forEach((header) => {
        xhttp.setRequestHeader(header, headers[header]);
      });
    }
    if (contentType == false) {
      xhttp.setRequestHeader("Content-type", "multipart/form-data");
      const formData = new FormData();
      Object.keys(data).forEach((k) => {
        formData.append(k, data[k]);
      });
      xhttp.send(formData);
    } else {
      xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
      let params = new URLSearchParams();
      Object.keys(data).forEach((k) => {
        params.append(k, data[k]);
      });
      xhttp.send(params.toString());
    }
  }

  processResponse(responseObj) {
    let resOut = {};
    let type = responseObj.type ? responseObj.type.toLowerCase() : responseObj.type;

    switch (type) {
      case "informational":
        resOut.status = "error";
        resOut.data = responseObj.data;
        break;
      case "validation":
        resOut.status = "validate";
        resOut.data = responseObj.data;
        resOut.code = responseObj.code;
        
        break;
      case "success":
        resOut.status = "success";
        if (responseObj.data?.items) {
          resOut.data = responseObj.data.items;
          resOut.totalPage = responseObj.data.page;
          resOut.totalData = responseObj.data.total;
        } else {
          resOut.data = responseObj.data;
        }

        break;
      case "sql":
        resOut.status = "error";
        resOut.data = responseObj.data;
        break;
      case "error":
        resOut.status = "error";
        resOut.data = responseObj.data;
        resOut.code = responseObj.code;
        break;
    }
    
    return resOut; //processed
  }

  
ajaxCaller(obj, callback, notAuth = false) {
    const _this = this;
  
    if (!notAuth) {
      obj.headers = { Authorization: "Bearer " + this.token };
    }
  
    // Set language header
    obj.headers = {
      ...obj.headers,
      lan: appConst.isBangla ? "bd" : "en",
    };
  
    axios({
      ...obj,
      validateStatus: () => true, 
    })
      .then((res) => {
  
        callback(res.data);
  
        if (res.status === 401 && !notAuth) {
          window.__onLogout__();
        }
      })
      .catch((err) => {
        console.error("Axios error:", err);
  
        if (err?.response?.data) {
          callback(err.response.data);
        } else {
          callback({
            success: 0,
            message: "Network error. Please try again.",
          });
        }
  
        if (err?.response?.status === 401 && !notAuth) {
          window.__onLogout__();
        }
      });
  }
  
  ajaxCaller12(obj, callback, notAuth = false) {
    
    const _this = this;
    if (!notAuth) {
      obj.headers = { Authorization: "Bearer " + this.token};
    }
    if(appConst.isBangla){
      if(obj.headers){
        obj.headers['lan'] = 'bd';
      }else{
        obj.headers ={
          lan:"bd"
        }
      }
    }else{
      if(obj.headers){
        obj.headers['lan'] = 'en';
      }else{
        obj.headers ={
          lan:"en"
        }
      }
    }
    axios(obj)
      .then((res) => {
        //console.log(res.data)
        if (res.status == 200) {
          if(res.data.code==200){

            //callback(_this.processResponse(res.data));
            callback(res.data);
          }else{
            //callback(_this.processResponse(res.data));
            callback(res.data);
          }
        } else if (res.status == 401 && notAuth == false) {
          window.__onLogout__();
        } else {
          //callback(_this.processResponse(res.data));
          callback(res.data);
        }
      })
      .catch((err) => {
        console.error(err);
        
        if (err?.response?.status == 401 && notAuth == false) {
          window.__onLogout__();
          return;
        } else {
          //callback(_this.processResponse(err.data));
          callback(err.data);
        }
      });
  }

  ajaxCaller2(obj, callback, notAuth = false) {
    const _this = this;
    if (!notAuth) {
      obj.headers = { Authorization: "Bearer " + this.token };
    }
    if(appConst.isBangla){
      if(obj.headers){
        obj.headers['lan'] = 'bd';
      }else{
        obj.headers ={
          lan:"bd"
        }
      }
    }else{
      if(obj.headers){
        obj.headers['lan'] = 'en';
      }else{
        obj.headers ={
          lan:"en"
        }
      }
    }
    axios(obj)
      .then((res) => {
        if (res.status == 200) {
          callback(_this.processResponse(res.data));
        } else if (res.status == 401 && notAuth == false) {
          window.__onLogout__();
        } else {
          callback(res.data);
        }
      })
      .catch((err) => {
        if (err.response.status == 401 && notAuth == false) {
          window.__onLogout__();
          return;
        } else {
          callback(res.data);
        }
      });
  }
  ajaxCaller3(obj, callback, notAuth = false) {
    const _this = this;
    if (!notAuth) {
      obj.headers = { Authorization: "Bearer " + this.token };
    }
    if(appConst.isBangla){
      if(obj.headers){
        obj.headers['lan'] = 'bd';
      }else{
        obj.headers ={
          lan:"bd"
        }
      }
    }else{
      if(obj.headers){
        obj.headers['lan'] = 'en';
      }else{
        obj.headers ={
          lan:"en"
        }
      }
    }
    axios(obj)
      .then((res) => {
        if (res.status == 200) {
          callback(res.data);
        } else if (res.status == 401 && notAuth == false) {
          window.__onLogout__();
        } else {
          callback(res.data);
        }
      })
      .catch((err) => {
        if (err.response.status == 401 && notAuth == false) {
          window.__onLogout__();
          return;
        } else {
          callback(res.data);
        }
      });
  }

  getParentCategories = (callback) => {
    const url = this.url + "/api/v1/categories/hierarchy",
      _this = this;
    this.ajaxCaller({ url: url, method: "get", data: {} }, callback);
  };

  getParentTopics = (callback) => {
    const url = this.url + "/api/v1/getParentTopics",
      _this = this;
    this.ajaxCaller({ url: url, method: "get", data: {} }, callback);
  };
  getAllRoles = (callback) => {
    const url = this.url + "/api/v1/allRoles",
      _this = this;
    this.ajaxCaller({ url: url, method: "get", data: {} }, callback);
  };

  getSingleData(apiPrefix, id, callback) {
    const url = this.url + "/api/v1/" + apiPrefix + "/" + id,
      _this = this;
    this.ajaxCaller({ url: url, method: "get", data: {} }, callback);
  }


  getSingleDataAd(apiPrefix, id, callback) {
    const url = this.url + "/api/v1/" + apiPrefix + "/" + id+"?isCat=1",
      _this = this;
    this.ajaxCaller({ url: url, method: "get", data: {} }, callback);
  }
  delete(apiPrefix, id, callback) {
    const url = this.url + "/api/v1/" + apiPrefix + "/" + id,
      _this = this;
    const formData = new FormData();
    formData.append("_method", "DELETE");
    this.ajaxCaller({ url: url, method: "post", data: formData }, callback);
  }

  logout(callback) {
    const url = this.url + "/api/v1/logout",
      _this = this;
    this.ajaxCaller({ url: url, method: "post", data: {} }, callback);
  }

  login(route, email, password, callback) {
    const formData = new FormData();
    const url = this.url + route,
      _this = this;
    formData.append("user_name", email);
    formData.append("password", password);
    this.ajaxCaller2({ url: url, method: "post", data: {user_name: email, password: password} }, callback, true);
  }

  ajaxCaller2(obj, callback, notAuth = false) {
    if (!notAuth) {
      obj.headers = {
        Authorization: "Bearer " + this.token,
        "Content-Type": "application/octet-stream",
      };
    }
    if(appConst.isBangla){
      if(obj.headers){
        obj.headers['lan'] = 'bd';
      }else{
        obj.headers ={
          lan:"bd"
        }
      }
    }else{
      if(obj.headers){
        obj.headers['lan'] = 'en';
      }else{
        obj.headers ={
          lan:"en"
        }
      }
    }
    axios(obj)
      .then((res) => {
        //console.log(res)
        if (res.status == 200) {
          callback(res.data);
        } else if (res.status == 401 && notAuth == false) {
          window.__onLogout__();
        } else {
          callback(null);
        }
      })
      .catch((err) => {
        //console.log(err.response.data)
        if (err.response.status == 401 && notAuth == false) {
          window.__onLogout__();
        } else {
          //callback(res.data);
          callback(err.response.data);
        }
      });
  }
  chunkUpload(chunk, name, callback) {
    let formData = new FormData();
    formData.append("file", chunk);
    formData.append("requested_name", chunk.requestedFileName);
    formData.append("uploaded_name", chunk.uploadedFileName);
    formData.append("mime", chunk.mime);
    
    this.ajaxCaller({ url: this.url + "/api/v1/files", method: "post", data: formData }, (returnData) => {
      if (callback) callback(returnData);
    });
  }
  chunkUploadLast(chunk, name, callback) {
    let formData = new FormData();
    formData.append("file", chunk);
    formData.append("is_last", "1");
    formData.append("requested_name", chunk.requestedFileName);
    formData.append("uploaded_name", chunk.uploadedFileName);
    formData.append("mime", chunk.mime);



    this.ajaxCaller(
      {
        url: this.url + "/api/v1/files",
        method: "post",
        headers: {},
        data: formData,
      },
      (returnData) => {
        if (callback) callback(returnData);
      }
    );
  }

  abortChunkUpload(data, callback) {
    let formData = new FormData();
    Object.keys(data).forEach((k) => {
      formData.append(k, data[k]);
    });
    this.ajaxCaller(
      {
        url: this.url + "/api/v1/files",
        method: "post",
        headers: {},
        data: formData,
      },
      (returnData) => {
        if (callback) callback(returnData);
      }
    );
  }
  getUserData(route, callback) {
    let url = this.url
    this.ajaxCaller({ url: url+route, method: "get", data: {} }, callback);
  }

  getAppSettings() {}

  getDemoResponse() {
    return new Promise((resolve, reject) => {
      resolve({
        status: "success",
        data: [],
      });
    });
  }

  checkUnique(modulePrefix, slug, callback) {
    let url = this.url + "/api/v1/" + modulePrefix + "/slugCheck/" + slug;
    this.ajaxCaller(
      {
        url: url,
        method: "GET",
        data: {},
        headers: {},
      },
      (returnData) => {
        if (callback) callback(returnData);
      }
    );
  }
  checkSlugV1(table, coloum, slug, callback) {
    let url = this.url + "/api/v1/check/" + slug + "?table=" + table + "&column=" + coloum + "&condition=like";
    this.ajaxCaller(
      {
        url: url,
        method: "GET",
        data: {},
      },
      (returnData) => {
        if (callback) callback(returnData);
      }
    );
  }
  getInitialComponentData(callback) {
    const url = this.url + "/api/v1/components?perPage=100",
      _this = this;
    this.ajaxCaller({ url: url, method: "get", data: {} }, callback);
  }

  getAllTemplates(callback) {
    const url = this.url + "/api/v1/templates";
    this.ajaxCaller({ url: url, method: "get", data: {} }, callback);
  }
  getTemplateByOrPageDataById(id,type, callback,data=null) {
    let url = "";
    switch(type){
      case "":
      case "template":
        url = this.url + "/api/v1/templates/" + id;
      break;
      // case "page":
      //   ///page-builder-data?type=page&id=4&backEnd=1&includeBlocks=-1&layout=1
      //   url = this.url + "/api/v1/page-builder-data?type="+type+"&id="+id+"&backEnd=1&includeBlocks=-1&layout=1";
      // break;
      default:
        // http://192.168.101.249/api/v1/page-builder-data?type=category&id=38&backEnd=1&includeBlocks=-1&layout=1
        url = this.url + "/api/v1/page-builder-data?type="+type+"&id="+id+"&backEnd=1&layout=1";
        if(data){
          let urlParams = new URLSearchParams();
          Object.keys(data).forEach(key=>{
            urlParams.append(key,data[key])
          });
          url+="&"+urlParams.toString();
        }

    }
    this.ajaxCaller({ url: url, method: "get", data: {} }, callback);
  }

  getpageData(id, getLayout = false, type = "template", backEnd = 1, includeBlocks, excludeBlocks, getPosts, callback) {
    let url = this.url + "/api/v1/test/page/" + id;
    let urlparams = new URLSearchParams();
    urlparams.append("layout", getLayout);
    urlparams.append("type", type);
    urlparams.append("backEnd", backEnd);
    urlparams.append("includeBlocks", includeBlocks);
    url += "?" + urlparams.toString();
    this.ajaxCaller({ url: url, method: "get", data: {} }, callback);
  }
  getBlockData(id, backEnd = 1, getPosts, callback) {
    let url = this.url + "/api/v1/test/page/" + id;
    let urlparams = new URLSearchParams();
    urlparams.append("backEnd", backEnd);
    urlparams.append("getPosts", getPosts);
    
    url += "?" + urlparams.toString();
    this.ajaxCaller({ url: url, method: "get", data: {} }, callback);
  }
  getDataByChinFilter(query, callback) {
    let url = this.url + "/api/v1/chain-data?filters="+JSON.stringify(query);
    this.ajaxCaller({ url: url, method: "get", data: {} }, callback);
  }

  getBlockUser(type,id,device,blockId, callback) {
    let url = this.url + "/api/v1/blocks-users?id="+id+"&type="+type+"&device="+device+"&block="+blockId;
    this.ajaxCaller({ url: url, method: "get", data: {} }, callback);
  }

  //block-list?id=47&type=page&device=lg
  getBlockList(type,id,device, callback) {
    let url = this.url + "/api/v1/block-list?id="+id+"&type="+type+"&device="+device;
    this.ajaxCaller({ url: url, method: "get", data: {} }, callback);
  }


   //block-list?id=47&type=page&device=lg
   getSingleBlock(type,id,device,block, callback) {
     ///api/v1/get-component?id=47&type=page&block=1  
    let url = this.url + "/api/v1/get-component?id="+id+"&type="+type+"&block="+block+"&device="+device;
    this.ajaxCaller({ url: url, method: "get", data: {} }, callback);
  }


  dataServeApi(obj,callback){
    
    let url = this.url + "/api/v1/data-serve";
    let urlparams = new URLSearchParams();
    const { type, fields, dependency, filterType, filterItemIds, postIds, pagination, limit,
      sortBy, sorting, search, include,exclude,page,date,isPrimaryCat,format} = obj;

    if(type) urlparams.append('type', type);
    if(fields) urlparams.append('fields', JSON.stringify(fields)); 
    if(dependency==0||dependency==1) urlparams.append('dependency', dependency);
    if(filterType) urlparams.append('filterType', filterType);
    if(filterItemIds) urlparams.append('filterItemIds', JSON.stringify(filterItemIds));
    if(postIds) urlparams.append('postIds', postIds);
    if(pagination) urlparams.append('pagination', pagination);
    if(limit) urlparams.append('limit', limit);
    if(sortBy) urlparams.append('sortBy',sortBy);
    if(sorting) urlparams.append('sorting',sorting);
    if(search) urlparams.append('search',JSON.stringify(search));
    if(include) urlparams.append('include',include);
    if(exclude) urlparams.append('exclude',exclude);
    if(page) urlparams.append('page',page);
    if(date) urlparams.append('date',date);
    if(format) urlparams.append('format',format);
    if(isPrimaryCat) urlparams.append('isPrimaryCat',isPrimaryCat);
    
    url =  url+"?"+urlparams.toString();
    
    this.ajaxCaller({ url:url, method: "get", data: {} }, callback);
    //http://192.168.101.249/api/v1/data-serve?type=post&fields=["id","title","permalink","type","lead","description"]&dependency=1&filterType=category&filterItemIds=[367]&
    // postIds=[367]&pagination=1&limit=10&sortBy=created_at&sorting=desc&page=2&search=[{"key":"title","value":"sds","condition":"like"}]&include=[367]&exclude=[367]
  }

  getAdSizes (obj,isMobile, callback){
    let url = this.url + "/api/v1/ad-data-serve?size_list=1";
    this.ajaxCaller({ url:url, method: "get", data: {} }, callback);
  }
  getAllPositions = (callback) =>{
    let url = this.url + "/api/v1/page-builder-data?backEnd=1&positions=1";
    this.ajaxCaller({ url:url, method: "get", data: {} }, callback);
  }
  getClient = (callback) => {
    let url = this.url + "/api/v1/clients?perPage=-1";
    this.ajaxCaller({ url:url, method: "get", data: {} }, callback);
  }
  getAgencies = (callback) => {
    let url = this.url + "/api/v1/ad-agencies?perPage=-1";
    this.ajaxCaller({ url:url, method: "get", data: {} }, callback);
  }

  getSchedules = (callback) => {
    let url = this.url + "/api/v1/ad-data-serve?schedule_list=1";
    this.ajaxCaller({ url:url, method: "get", data: {} }, callback);
  }

  postSaveTodaysSections = (data,callback) => {
    let url = this.url + "/api/v1/todays-sections";
    this.ajaxCaller({ url:url, method: "post", data: data }, callback);
  }
  getTodaysNewsPager = (date,callback) => {
    let url = this.url + "/api/v1/todays-papers?date="+date;
    this.ajaxCaller({ url:url, method: "get", data: {} }, callback);
  }


  lockDataThoughApi = (date,callback)=>{

    let url = this.url + "/api/v1/edit-access-lock";
    this.ajaxCaller({ url:url, method: "post", data: date }, callback);
  }
  saveBlockDataMapping = (data,callback) => {
    let url = this.url + "/api/v1/set-component";
    this.ajaxCaller({ url:url, method: "post", data: data }, callback);
  }

  getHomePageData = (callback)=>{
    let url = this.url + "/api/v1/pages?perPage=1&page=0&filters=%5B%7B%22key%22%3A%22is_home%22%2C%22condition%22%3A%22%3D%22%2C%22value%22%3A%221%22%7D%5D";
    this.ajaxCaller({ url:url, method: "get", data: {} }, callback);
  }


  createEpaperWithSingleJSONObj( datas, callback) {
    const url = this.url + "/api/v1/epaper", _this = this;
    const formData = new FormData();
    Object.keys(datas).forEach((key) => {
      formData.append(key, datas[key]);
    });
    _this.ajaxCaller({ url: url, method: "post", data: formData }, callback);
  }

  getEpaperData (date,callback,editionId = null, pageId = null){
    let url = this.url + "/api/v1/epaper?date="+date;

    if(editionId){
      url += "&edition="+editionId
    }
    
    if(pageId){
      url += "&page="+pageId
    }
    this.ajaxCaller({ url:url, method: "get", data: {} }, callback);
  }
  getEpaperEfileData (date,callback,editionName, pageNo){
    let url = this.url + "/api/v1/e-files?date="+date+"&editionName="+editionName+"&pageNo="+pageNo;
    this.ajaxCaller({ url:url, method: "get", data: {} }, callback);
  }


  updateEpaperData (datas,callback){
    const url = this.url + "/api/v1/epaper-update";

    const formData = new FormData();
    Object.keys(datas).forEach((key) => {
      formData.append(key, datas[key]);
    });
    this.ajaxCaller({ url:url, method: "post", data: formData,headers:{} }, callback);
  }

  getDefaultEpaperList( callback) {
    const url = this.url + "/api/v1/epapers?defaultEditions=1",
      _this = this;
    this.ajaxCaller({ url: url, method: "get", data: {} }, callback);
  }
  getDefaultEpaperListDateOnly(month,year, callback) {
    const url = this.url + `/api/v1/epapers?filter={"m":"${month}","y":"${year}"}`;
    this.ajaxCaller({ url: url, method: "get", data: {} }, callback);
  }
  updateOptions (datas,callback){
    const url = this.url + "/api/v1/options-update";
    const formData = new FormData();
    Object.keys(datas).forEach((key) => {
      formData.append(key, datas[key]);
    });
    this.ajaxCaller({ url:url, method: "post", data: formData,headers:{} }, callback);
  }
  getBlockListData(id,type,device, callback,withOutPermission = false) {
  let url = this.url + `/api/v1/block-list?id=${id}&type=${type}&device=${device}&perPage=-1`,
      _this = this;
      if(withOutPermission){
        url+="&wPer=1"
      }
    this.ajaxCaller({ url: url, method: "get", data: {} }, callback);
  }

  checkBlockRef (id,type,device,block,callback){
    let url = this.url + `/api/v1/check-ref?id=${id}&type=${type}&device=${device}&block=${block}`,
    _this = this;
    this.ajaxCaller3({ url: url, method: "get", data: {} }, callback);
  }

  postComments = (data,callback) => {
    let url = this.url + "/api/v1/comments";
    this.ajaxCaller({ url:url, method: "post", data: data }, callback);
  }
  cacheUpdate = (id, type,callback) => {
    let url = this.url + "/api/v1/cache/redis-update";
    this.ajaxCaller({ url:url, method: "post", data: {
      id, type
    } }, callback);
  }
  cacheDelete = (id, type,callback) => {
    let url = this.url + "/api/v1/cache/redis-delete";
    this.ajaxCaller({ url:url, method: "post", data: {
      id, type
    } }, callback);
  }

  epaperFileUpload = (data, file, isCutoutFile = false, callback=null)=>{
    const formData = new FormData();
    if(isCutoutFile){
      formData.append("file",file);
    }else{
      formData.append("pFile",file);
    }
    formData.append("data",JSON.stringify(data));
    this.ajaxCaller({ url: this.url + "/api/v1/efup", method: "post", data: formData }, (returnData) => {
      if (callback) callback(returnData);
    });
  }
  epaperFileDelete = (data, callback=null)=>{
    const formData = new FormData();
    formData.append("data",JSON.stringify(data));
    this.ajaxCaller({ url: this.url + "/api/v1/efde", method: "post", data: formData }, (returnData) => {
      if (callback) callback(returnData);
    });
  }
  clearPostCache = (permalink, callback)=>{
    const url = appConst.siteLink+'/remove-level-cache?permalink='+permalink,
      _this = this;
    const formData = new FormData();
    formData.append("_method", "DELETE");
    this.ajaxCaller({ url: url, method: "post", data: formData }, callback);
  }
  pmModList = (id,callback)=>{
    let url = this.url + `/api/v1/pm-mod-list?id=`+id;
    this.ajaxCaller({ url: url, method: "get", data: {} }, callback);
  }
  pmModGet = (id,callback)=>{
    let url = this.url + `/api/v1/pm-mod-get?id=${id}`;
    this.ajaxCaller({ url: url, method: "get", data: {} }, callback);
  }


  //work api start here
  deposit_history = (route, callback) => {
    let url = this.url + route
    this.ajaxCaller({url: url, method: 'get', data: {}}, callback)
  }
  club_fetch = (route, callback) => {
    let url = this.url + route
    this.ajaxCaller({url: url, method: 'GET', data: {}}, callback)
  }
  account_create = (route, body, callback) => {
    let url = this.url + route
    this.ajaxCaller({url: url, method: 'POST', data: body}, callback)
  }
  account_actions = (route, method, body, callback) => {
    let url = this.url + route
    this.ajaxCaller({url: url, method: method, data: body}, callback)
  }
  work_data = (route, callback) => {
    let url = this.url + route
    this.ajaxCaller({url: url, method: 'GET', data: {}}, callback)
  }
  work_actions = (route, method, body, callback) => {
    let url = this.url + route
    this.ajaxCaller({
      url: url,
      method: method,
      data: {
        title_id: body.d_title_id,
        sub_title: body.d_sub_title,
        sub_title_id: body.d_sub_title_id,
        option: body.d_option_title,
        option_id: body.d_option_title_id,
        work_amount: body.d_work_amount,
        work_rate: body.d_option_rate
      }
    }, callback)
  }
}


export default ServerApi;
